const BDC = {
    HOME: {
        RESOURCE_ID: 'benefitsDocumentCreator',
    },
};

export default BDC;
